import { PrizmCountryIsoCode } from '../../enums/country-iso-code';

export const PRIZM_ENGLISH_LANGUAGE_COUNTRIES: Record<PrizmCountryIsoCode, string> = {
  [PrizmCountryIsoCode.AD]: `Andorra`,
  [PrizmCountryIsoCode.AE]: `United Arab Emirates`,
  [PrizmCountryIsoCode.AF]: `Afghanistan`,
  [PrizmCountryIsoCode.AG]: `Antigua and Barbuda`,
  [PrizmCountryIsoCode.AI]: `Anguilla`,
  [PrizmCountryIsoCode.AL]: `Albania`,
  [PrizmCountryIsoCode.AM]: `Armenia`,
  [PrizmCountryIsoCode.AO]: `Angola`,
  [PrizmCountryIsoCode.AR]: `Argentina`,
  [PrizmCountryIsoCode.AT]: `Austria`,
  [PrizmCountryIsoCode.AU]: `Australia`,
  [PrizmCountryIsoCode.AW]: `Aruba`,
  [PrizmCountryIsoCode.AZ]: `Azerbaijan`,
  [PrizmCountryIsoCode.BA]: `Bosnia and Herzegovina`,
  [PrizmCountryIsoCode.BB]: `Barbados`,
  [PrizmCountryIsoCode.BD]: `Bangladesh`,
  [PrizmCountryIsoCode.BE]: `Belgium`,
  [PrizmCountryIsoCode.BF]: `Burkina Faso`,
  [PrizmCountryIsoCode.BG]: `Bulgaria`,
  [PrizmCountryIsoCode.BH]: `Bahrain`,
  [PrizmCountryIsoCode.BI]: `Burundi`,
  [PrizmCountryIsoCode.BJ]: `Benin`,
  [PrizmCountryIsoCode.BM]: `Bermuda`,
  [PrizmCountryIsoCode.BN]: `Brunei Darussalam`,
  [PrizmCountryIsoCode.BO]: `Bolivia`,
  [PrizmCountryIsoCode.BQ]: `Bonaire, Sint Eustatius and Saba`,
  [PrizmCountryIsoCode.BR]: `Brazil`,
  [PrizmCountryIsoCode.BS]: `Bahamas`,
  [PrizmCountryIsoCode.BT]: `Bhutan`,
  [PrizmCountryIsoCode.BW]: `Botswana`,
  [PrizmCountryIsoCode.BY]: `Belarus`,
  [PrizmCountryIsoCode.BZ]: `Belize`,
  [PrizmCountryIsoCode.CA]: `Canada`,
  [PrizmCountryIsoCode.CD]: `Dem. Rep. Congo (Kinshasa)`,
  [PrizmCountryIsoCode.CF]: `Central African Republic`,
  [PrizmCountryIsoCode.CG]: `Congo (Brazzaville)`,
  [PrizmCountryIsoCode.CH]: `Switzerland`,
  [PrizmCountryIsoCode.CI]: `Côte d'Ivoire`,
  [PrizmCountryIsoCode.CL]: `Chile`,
  [PrizmCountryIsoCode.CM]: `Cameroon`,
  [PrizmCountryIsoCode.CN]: `China P.R.`,
  [PrizmCountryIsoCode.CO]: `Colombia`,
  [PrizmCountryIsoCode.CR]: `Costa Rica`,
  [PrizmCountryIsoCode.CU]: `Cuba`,
  [PrizmCountryIsoCode.CV]: `Cabo Verde`,
  [PrizmCountryIsoCode.CW]: `Curaçao`,
  [PrizmCountryIsoCode.CY]: `Cyprus`,
  [PrizmCountryIsoCode.CZ]: `Czech Republic`,
  [PrizmCountryIsoCode.DE]: `Germany`,
  [PrizmCountryIsoCode.DJ]: `Djibouti`,
  [PrizmCountryIsoCode.DK]: `Denmark`,
  [PrizmCountryIsoCode.DM]: `Dominica`,
  [PrizmCountryIsoCode.DO]: `Dominican Republic`,
  [PrizmCountryIsoCode.DZ]: `Algeria`,
  [PrizmCountryIsoCode.EC]: `Ecuador`,
  [PrizmCountryIsoCode.EE]: `Estonia`,
  [PrizmCountryIsoCode.EG]: `Egypt`,
  [PrizmCountryIsoCode.ER]: `Eritrea`,
  [PrizmCountryIsoCode.ES]: `Spain`,
  [PrizmCountryIsoCode.ET]: `Ethiopia`,
  [PrizmCountryIsoCode.FI]: `Finland`,
  [PrizmCountryIsoCode.FJ]: `Fiji`,
  [PrizmCountryIsoCode.FK]: `Falkland Islands`,
  [PrizmCountryIsoCode.FM]: `Fed. States of Micronesia`,
  [PrizmCountryIsoCode.FR]: `France`,
  [PrizmCountryIsoCode.GA]: `Gabon`,
  [PrizmCountryIsoCode.GB]: `United Kingdom`,
  [PrizmCountryIsoCode.GD]: `Grenada`,
  [PrizmCountryIsoCode.GE]: `Georgia`,
  [PrizmCountryIsoCode.GH]: `Ghana`,
  [PrizmCountryIsoCode.GI]: `Gibraltar`,
  [PrizmCountryIsoCode.GL]: `Greenland`,
  [PrizmCountryIsoCode.GM]: `Gambia`,
  [PrizmCountryIsoCode.GN]: `Guinea`,
  [PrizmCountryIsoCode.GQ]: `Equatorial Guinea`,
  [PrizmCountryIsoCode.GR]: `Greece`,
  [PrizmCountryIsoCode.GT]: `Guatemala`,
  [PrizmCountryIsoCode.GW]: `Guinea-Bissau`,
  [PrizmCountryIsoCode.GY]: `Guyana`,
  [PrizmCountryIsoCode.HK]: `Hong Kong`,
  [PrizmCountryIsoCode.HN]: `Honduras`,
  [PrizmCountryIsoCode.HR]: `Croatia`,
  [PrizmCountryIsoCode.HT]: `Haiti`,
  [PrizmCountryIsoCode.HU]: `Hungary`,
  [PrizmCountryIsoCode.ID]: `Indonesia`,
  [PrizmCountryIsoCode.IE]: `Ireland`,
  [PrizmCountryIsoCode.IL]: `Israel`,
  [PrizmCountryIsoCode.IN]: `India`,
  [PrizmCountryIsoCode.IQ]: `Iraq`,
  [PrizmCountryIsoCode.IR]: `Iran`,
  [PrizmCountryIsoCode.IS]: `Iceland`,
  [PrizmCountryIsoCode.IT]: `Italy`,
  [PrizmCountryIsoCode.JM]: `Jamaica`,
  [PrizmCountryIsoCode.JO]: `Jordan`,
  [PrizmCountryIsoCode.JP]: `Japan`,
  [PrizmCountryIsoCode.KE]: `Kenya`,
  [PrizmCountryIsoCode.KG]: `Kyrgyzstan`,
  [PrizmCountryIsoCode.KH]: `Cambodia`,
  [PrizmCountryIsoCode.KM]: `Comoros`,
  [PrizmCountryIsoCode.KN]: `Saint Kitts and Nevis`,
  [PrizmCountryIsoCode.KP]: `North Korea`,
  [PrizmCountryIsoCode.KR]: `South Korea`,
  [PrizmCountryIsoCode.KW]: `Kuwait`,
  [PrizmCountryIsoCode.KY]: `Cayman Islands`,
  [PrizmCountryIsoCode.KZ]: `Kazakhstan`,
  [PrizmCountryIsoCode.LA]: `Laos`,
  [PrizmCountryIsoCode.LB]: `Lebanon`,
  [PrizmCountryIsoCode.LC]: `Saint Lucia`,
  [PrizmCountryIsoCode.LI]: `Liechtenstein`,
  [PrizmCountryIsoCode.LK]: `Sri Lanka`,
  [PrizmCountryIsoCode.LR]: `Liberia`,
  [PrizmCountryIsoCode.LS]: `Lesotho`,
  [PrizmCountryIsoCode.LT]: `Lithuania`,
  [PrizmCountryIsoCode.LU]: `Luxembourg`,
  [PrizmCountryIsoCode.LV]: `Latvia`,
  [PrizmCountryIsoCode.LY]: `Libya`,
  [PrizmCountryIsoCode.MA]: `Morocco`,
  [PrizmCountryIsoCode.MC]: `Monaco`,
  [PrizmCountryIsoCode.MD]: `Moldova`,
  [PrizmCountryIsoCode.ME]: `Montenegro`,
  [PrizmCountryIsoCode.MG]: `Madagascar`,
  [PrizmCountryIsoCode.MK]: `North Macedonia`,
  [PrizmCountryIsoCode.ML]: `Mali`,
  [PrizmCountryIsoCode.MM]: `Myanmar (Burma)`,
  [PrizmCountryIsoCode.MN]: `Mongolia`,
  [PrizmCountryIsoCode.MO]: `Macau`,
  [PrizmCountryIsoCode.MR]: `Mauritania`,
  [PrizmCountryIsoCode.MS]: `Montserrat`,
  [PrizmCountryIsoCode.MT]: `Malta`,
  [PrizmCountryIsoCode.MU]: `Mauritius`,
  [PrizmCountryIsoCode.MV]: `Maldives`,
  [PrizmCountryIsoCode.MW]: `Malawi`,
  [PrizmCountryIsoCode.MX]: `Mexico`,
  [PrizmCountryIsoCode.MY]: `Malaysia`,
  [PrizmCountryIsoCode.MZ]: `Mozambique`,
  [PrizmCountryIsoCode.NA]: `Namibia`,
  [PrizmCountryIsoCode.NE]: `Niger`,
  [PrizmCountryIsoCode.NG]: `Nigeria`,
  [PrizmCountryIsoCode.NI]: `Nicaragua`,
  [PrizmCountryIsoCode.NL]: `Netherlands`,
  [PrizmCountryIsoCode.NO]: `Norway`,
  [PrizmCountryIsoCode.NP]: `Nepal`,
  [PrizmCountryIsoCode.NZ]: `New Zealand`,
  [PrizmCountryIsoCode.OM]: `Oman`,
  [PrizmCountryIsoCode.PA]: `Panama`,
  [PrizmCountryIsoCode.PE]: `Peru`,
  [PrizmCountryIsoCode.PF]: `French Polynesia (Tahiti)`,
  [PrizmCountryIsoCode.PG]: `Papua New Guinea`,
  [PrizmCountryIsoCode.PH]: `Philippines`,
  [PrizmCountryIsoCode.PK]: `Pakistan`,
  [PrizmCountryIsoCode.PL]: `Poland`,
  [PrizmCountryIsoCode.PT]: `Portugal`,
  [PrizmCountryIsoCode.PW]: `Palau`,
  [PrizmCountryIsoCode.PY]: `Paraguay`,
  [PrizmCountryIsoCode.QA]: `Qatar`,
  [PrizmCountryIsoCode.RO]: `Romania`,
  [PrizmCountryIsoCode.RS]: `Serbia`,
  [PrizmCountryIsoCode.RU]: `Russia`,
  [PrizmCountryIsoCode.RW]: `Rwanda`,
  [PrizmCountryIsoCode.SA]: `Saudi Arabia`,
  [PrizmCountryIsoCode.SB]: `Solomon Islands`,
  [PrizmCountryIsoCode.SC]: `Seychelles`,
  [PrizmCountryIsoCode.SD]: `Sudan`,
  [PrizmCountryIsoCode.SE]: `Sweden`,
  [PrizmCountryIsoCode.SG]: `Singapore`,
  [PrizmCountryIsoCode.SH]: `Saint Helena`,
  [PrizmCountryIsoCode.SI]: `Slovenia`,
  [PrizmCountryIsoCode.SK]: `Slovakia`,
  [PrizmCountryIsoCode.SL]: `Sierra Leone`,
  [PrizmCountryIsoCode.SM]: `San Marino`,
  [PrizmCountryIsoCode.SN]: `Senegal`,
  [PrizmCountryIsoCode.SO]: `Somalia`,
  [PrizmCountryIsoCode.SR]: `Suriname`,
  [PrizmCountryIsoCode.ST]: `São Tomé and Príncipe`,
  [PrizmCountryIsoCode.SV]: `El Salvador`,
  [PrizmCountryIsoCode.SX]: `Sint Maarten`,
  [PrizmCountryIsoCode.SY]: `Syrian Arab Republic`,
  [PrizmCountryIsoCode.SZ]: `Eswatini`,
  [PrizmCountryIsoCode.TC]: `Turks and Caicos Islands`,
  [PrizmCountryIsoCode.TD]: `Chad`,
  [PrizmCountryIsoCode.TG]: `Togo`,
  [PrizmCountryIsoCode.TH]: `Thailand`,
  [PrizmCountryIsoCode.TJ]: `Tajikistan`,
  [PrizmCountryIsoCode.TL]: `Timor-Leste`,
  [PrizmCountryIsoCode.TM]: `Turkmenistan`,
  [PrizmCountryIsoCode.TN]: `Tunisia`,
  [PrizmCountryIsoCode.TO]: `Tonga`,
  [PrizmCountryIsoCode.TR]: `Turkey`,
  [PrizmCountryIsoCode.TT]: `Trinidad and Tobago`,
  [PrizmCountryIsoCode.TW]: `Taiwan`,
  [PrizmCountryIsoCode.TZ]: `Tanzania`,
  [PrizmCountryIsoCode.UA]: `Ukraine`,
  [PrizmCountryIsoCode.UG]: `Uganda`,
  [PrizmCountryIsoCode.US]: `USA`,
  [PrizmCountryIsoCode.UY]: `Uruguay`,
  [PrizmCountryIsoCode.UZ]: `Uzbekistan`,
  [PrizmCountryIsoCode.VC]: `Saint Vincent and the Grenadines`,
  [PrizmCountryIsoCode.VE]: `Venezuela`,
  [PrizmCountryIsoCode.VG]: `British Virgin Islands`,
  [PrizmCountryIsoCode.VN]: `Vietnam`,
  [PrizmCountryIsoCode.VU]: `Vanuatu`,
  [PrizmCountryIsoCode.WS]: `Samoa`,
  [PrizmCountryIsoCode.YE]: `Yemen`,
  [PrizmCountryIsoCode.ZA]: `South Africa`,
  [PrizmCountryIsoCode.ZM]: `Zambia`,
  [PrizmCountryIsoCode.ZW]: `Zimbabwe`,
  [PrizmCountryIsoCode.XK]: `Republic of Kosovo`,
};
